/** Shared chart color palette. Used by both Recharts (web app) and visx (MCP App). */
export const CHART_COLORS = ['#8b5cf6', '#06b6d4', '#f59e0b', '#ef4444', '#22c55e', '#ec4899'];
